import StatusModel from 'Models/StatusModel';

export const adminActionsByIds = {
  status: StatusModel.LIST,
};

export const cookieSignedInAsAdminUser = 'signed_in_as_admin_user';
